// Yan yana karşılaştırma — spec §7.2. diffLines blokları iki kolona dağıtılır;
// <900px'te alt alta yığılır (CEO S11 responsive). Sol = mevcut metin (silinenler
// vurgulu), sağ = KK adayı (eklenenler vurgulu) → eski + yeni AYNI ANDA görünür.
import { diffLines, type Change } from "diff";
import { useMemo } from "react";

export interface SideBySideDiffProps {
  original: string;
  candidate: string;
}

export function SideBySideDiff({ original, candidate }: SideBySideDiffProps): JSX.Element {
  const parts: Change[] = useMemo(() => diffLines(original, candidate), [original, candidate]);
  const left = parts.filter((p) => !p.added); // mevcut metin (silinenler vurgulu)
  const right = parts.filter((p) => !p.removed); // aday (eklenenler vurgulu)

  const col = (items: Change[], highlight: "removed" | "added", title: string): JSX.Element => (
    <div
      className="flex-1 min-w-0 rounded overflow-auto"
      style={{
        border: "1px solid var(--color-border)",
        background: "var(--color-surface)",
        maxHeight: 480,
      }}
    >
      <div
        className="px-3 py-1.5 text-xs uppercase tracking-wider sticky top-0"
        style={{ background: "var(--color-bg)", color: "var(--color-text-3)" }}
      >
        {title}
      </div>
      {items.map((p, i) => (
        <div
          key={i}
          style={{
            padding: "4px 12px",
            whiteSpace: "pre-wrap",
            fontFamily: "var(--font-sans)",
            fontSize: "0.85rem",
            background: p[highlight]
              ? highlight === "removed"
                ? "color-mix(in srgb, var(--color-error) 10%, white)"
                : "color-mix(in srgb, var(--color-success) 10%, white)"
              : "transparent",
          }}
        >
          {p.value}
        </div>
      ))}
    </div>
  );

  return (
    <div className="flex gap-3 flex-col min-[900px]:flex-row">
      {col(left, "removed", "Mevcut Metin")}
      {col(right, "added", "KK Adayı")}
    </div>
  );
}
